export const generateKey = () => {
  return `${new Date().getTime()}_${Math.random()}`;
};
